import fetcher from '../utils/api';

const folderService = {
  listFolder: async ({ searchQuery, parentFolderId, filterScribes }) => {
    const additionalParams = [];
    // file name query

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`file_nameq=${encodeURIComponent(searchQuery.trim())}`);
    }

    if (!!parentFolderId && parentFolderId.trim().length > 1) {
      additionalParams.push(`parent_id=${encodeURIComponent(parentFolderId.trim())}`);
    } else if (parentFolderId === null) {
      additionalParams.push(`parent_id=${encodeURIComponent(parentFolderId)}`);
    }

    if (filterScribes) {
      additionalParams.push(`filter_scribes=${encodeURIComponent(filterScribes)}`);
    }

    return fetcher('folders/' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  },
  getFolder: async (id, filterScribes) => {
    const additionalParams = [];

    if (filterScribes) {
      additionalParams.push(`filter_scribes=${encodeURIComponent(filterScribes)}`);
    }
    return fetcher(`folders/${id}/` + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  },
  createFolder: async (body) => fetcher(`folders/`, 'POST', true, body),
  editFolder: async (id, body) => fetcher(`folders/${id}/`, 'PATCH', true, body),
  deleteFolder: async (id) => fetcher(`folders/${id}/`, 'DELETE', true)
};

export default folderService;
